import { render, staticRenderFns } from "./UnassignedDealsTable.vue?vue&type=template&id=332e3960&scoped=true&"
import script from "./UnassignedDealsTable.vue?vue&type=script&lang=js&"
export * from "./UnassignedDealsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332e3960",
  null
  
)

export default component.exports